import { createAction, props } from '@ngrx/store';

import { CreateInvitationRequest, GetResponse, Invitation } from '@vi-iot/client';

export namespace NewInvitationActions {
  export enum Type {
    CREATE_INVITATION_INIT = '[INVITATION] Create Invitation Init',
    CREATE_INVITATION = '[INVITATION] Create Invitation',
    CREATE_INVITATION_SUCCESS = '[INVITATION] Create Invitation Success',
    CREATE_INVITATION_ERROR = '[INVITATION] Create Invitation Error',
  }

  export const createInvitationInit = createAction(Type.CREATE_INVITATION_INIT);

  export const createInvitation = createAction(
    Type.CREATE_INVITATION,
    props<{
      request: CreateInvitationRequest;
    }>()
  );

  export const createInvitationSuccess = createAction(
    Type.CREATE_INVITATION_SUCCESS,
    props<{
      response: GetResponse<Invitation>;
      gatewaySerial: string;
    }>()
  );

  export const createInvitationError = createAction(
    Type.CREATE_INVITATION_ERROR,
    props<{
      error: {
        errorType?: string;
        message?: string;
        statusCode?: number;
      };
    }>()
  );
}
